// PDF Facile - Document Categories and Documents Data
// Structure normalisée avec adresses décomposées

export const CATEGORIES = [
  {
    id: "attestations",
    name: "Attestations et déclarations",
    description: "Attestations sur l'honneur, d'hébergement, de domicile et déclarations officielles.",
    icon: "FileCheck",
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=400&q=80"
  },
  {
    id: "resiliation",
    name: "Résiliations et démarches contractuelles",
    description: "Lettres de résiliation pour assurances, abonnements, énergie et logement.",
    icon: "FileX",
    image: "https://images.unsplash.com/photo-1586957960362-65815d739527?w=400&q=80"
  },
  {
    id: "reclamations",
    name: "Réclamations et litiges",
    description: "Réclamations, demandes de remboursement, contestations et mises en demeure.",
    icon: "AlertCircle",
    image: "https://images.unsplash.com/photo-1583521214690-73421a1829a9?w=400&q=80"
  },
  {
    id: "logement",
    name: "Logement et vie quotidienne",
    description: "Courriers au bailleur, syndic, mairie et demandes de logement.",
    icon: "Home",
    image: "https://images.pexels.com/photos/7578984/pexels-photo-7578984.jpeg?w=400"
  },
  {
    id: "travail",
    name: "Travail et études",
    description: "Lettres pour employeurs, demandes de stage, lettres de motivation.",
    icon: "Briefcase",
    image: "https://images.unsplash.com/photo-1601485770245-9abd905abc7b?w=400&q=80"
  }
];

export const DOCUMENTS_LIST = {
  attestations: [
    { id: "attestation-honneur", name: "Attestation sur l'honneur", description: "Déclarez un fait ou une situation de manière officielle et juridiquement valable." },
    { id: "attestation-hebergement", name: "Attestation d'hébergement", description: "Certifiez qu'une personne est hébergée à votre domicile." },
    { id: "attestation-domicile", name: "Attestation de domicile", description: "Justifiez officiellement votre lieu de résidence actuel." },
    { id: "declaration-situation", name: "Déclaration de situation personnelle", description: "Déclarez votre situation familiale, professionnelle ou personnelle." },
    { id: "attestation-simple", name: "Attestation simple générique", description: "Attestation personnalisable pour tout type de déclaration officielle." }
  ],
  resiliation: [
    { id: "resiliation-assurance", name: "Lettre de résiliation assurance", description: "Résiliez votre contrat d'assurance (auto, habitation, santé...)." },
    { id: "resiliation-internet", name: "Lettre de résiliation internet / téléphone", description: "Résiliez votre abonnement internet, mobile ou téléphonie fixe." },
    { id: "resiliation-energie", name: "Lettre de résiliation énergie (EDF / gaz)", description: "Résiliez votre contrat d'électricité ou de gaz." },
    { id: "resiliation-salle-sport", name: "Lettre de résiliation salle de sport", description: "Résiliez votre abonnement de salle de sport ou fitness." },
    { id: "preavis-logement", name: "Lettre de préavis de départ (logement)", description: "Informez votre bailleur de votre intention de quitter le logement." }
  ],
  reclamations: [
    { id: "lettre-reclamation", name: "Lettre de réclamation", description: "Adressez une réclamation officielle à une entreprise ou administration." },
    { id: "demande-remboursement", name: "Lettre de demande de remboursement", description: "Demandez le remboursement d'un produit, service ou trop-perçu." },
    { id: "contestation", name: "Lettre de contestation", description: "Contestez une facture, des frais ou une décision administrative." },
    { id: "mise-en-demeure", name: "Lettre de mise en demeure simple", description: "Mettez en demeure un débiteur ou un prestataire défaillant." },
    { id: "lettre-explicative", name: "Lettre explicative / justificative", description: "Expliquez une situation ou justifiez une demande auprès d'un organisme." }
  ],
  logement: [
    { id: "lettre-bailleur", name: "Lettre au bailleur", description: "Adressez une demande ou signalez un problème à votre propriétaire." },
    { id: "lettre-syndic", name: "Lettre au syndic / copropriété", description: "Adressez une demande ou réclamation au syndic de copropriété." },
    { id: "demande-logement", name: "Demande de logement / inscription", description: "Candidatez pour un logement social ou une location." },
    { id: "lettre-mairie", name: "Lettre administrative simple (mairie, organisme)", description: "Adressez une demande officielle à la mairie ou un organisme public." }
  ],
  travail: [
    { id: "lettre-employeur", name: "Lettre pour employeur", description: "Adressez une demande officielle à votre employeur (absence, congé, aménagement)." },
    { id: "demande-exceptionnelle", name: "Lettre de demande exceptionnelle", description: "Formulez une demande particulière auprès de votre hiérarchie." },
    { id: "lettre-motivation", name: "Lettre de motivation simple", description: "Rédigez une lettre de motivation professionnelle et efficace." },
    { id: "demande-stage", name: "Lettre de demande de stage", description: "Candidatez pour un stage avec une lettre professionnelle." },
    { id: "lettre-etablissement", name: "Lettre pour établissement scolaire", description: "Adressez une demande à une école, collège, lycée ou université." }
  ]
};

// ============================================
// CHAMPS EXPÉDITEUR STANDARDISÉS
// ============================================
const EXPEDITEUR_FIELDS = [
  { name: "nom", label: "Nom", type: "text", required: true, placeholder: "DUPONT" },
  { name: "prenom", label: "Prénom", type: "text", required: true, placeholder: "Jean" },
  { name: "adresse_ligne1", label: "Adresse – ligne 1", type: "text", required: true, placeholder: "123 rue de la Paix" },
  { name: "adresse_ligne2", label: "Adresse – ligne 2", type: "text", required: false, placeholder: "Bâtiment A, Appartement 12 (optionnel)" },
  { name: "code_postal", label: "Code postal", type: "text", required: true, placeholder: "75001" },
  { name: "ville", label: "Ville", type: "text", required: true, placeholder: "Paris" }
];

// ============================================
// CHAMPS DESTINATAIRE STANDARDISÉS (avec organisme)
// ============================================
const createDestinataireFields = (organismeLabel, organismePlaceholder) => [
  { name: "dest_organisme", label: organismeLabel, type: "text", required: true, placeholder: organismePlaceholder },
  { name: "dest_service", label: "Service", type: "text", required: false, placeholder: "Service Résiliation (optionnel)" },
  { name: "dest_adresse_ligne1", label: "Adresse du destinataire – ligne 1", type: "text", required: true, placeholder: "TSA 12345" },
  { name: "dest_adresse_ligne2", label: "Adresse du destinataire – ligne 2", type: "text", required: false, placeholder: "(optionnel)" },
  { name: "dest_code_postal", label: "Code postal du destinataire", type: "text", required: true, placeholder: "75000" },
  { name: "dest_ville", label: "Ville du destinataire", type: "text", required: true, placeholder: "Paris" }
];

// ============================================
// DOCUMENTS COMPLETS
// ============================================
export const DOCUMENTS = {
  // ==========================================
  // ATTESTATIONS
  // ==========================================
  "attestation-honneur": {
    id: "attestation-honneur",
    category_id: "attestations",
    name: "Attestation sur l'honneur",
    description: "Déclarez un fait ou une situation de manière officielle et juridiquement valable.",
    fields: [
      ...EXPEDITEUR_FIELDS,
      { name: "date_naissance", label: "Date de naissance", type: "date", required: true },
      { name: "lieu_naissance", label: "Lieu de naissance", type: "text", required: true, placeholder: "Paris" },
      { name: "objet_attestation", label: "Objet de l'attestation", type: "textarea", required: true, placeholder: "atteste sur l'honneur que les informations fournies sont exactes..." },
      { name: "lieu_signature", label: "Fait à", type: "text", required: true, placeholder: "Paris" },
      { name: "date_document", label: "Date du document", type: "date", required: true }
    ]
  },
  
  "attestation-hebergement": {
    id: "attestation-hebergement",
    category_id: "attestations",
    name: "Attestation d'hébergement",
    description: "Certifiez qu'une personne est hébergée à votre domicile.",
    fields: [
      // Hébergeur (expéditeur)
      { name: "nom", label: "Nom de l'hébergeur", type: "text", required: true, placeholder: "DUPONT" },
      { name: "prenom", label: "Prénom de l'hébergeur", type: "text", required: true, placeholder: "Jean" },
      { name: "adresse_ligne1", label: "Adresse – ligne 1", type: "text", required: true, placeholder: "123 rue de la Paix" },
      { name: "adresse_ligne2", label: "Adresse – ligne 2", type: "text", required: false, placeholder: "(optionnel)" },
      { name: "code_postal", label: "Code postal", type: "text", required: true, placeholder: "75001" },
      { name: "ville", label: "Ville", type: "text", required: true, placeholder: "Paris" },
      { name: "hebergeur_date_naissance", label: "Date de naissance de l'hébergeur", type: "date", required: true },
      { name: "hebergeur_lieu_naissance", label: "Lieu de naissance de l'hébergeur", type: "text", required: true, placeholder: "Paris" },
      // Personne hébergée
      { name: "heberge_nom", label: "Nom de la personne hébergée", type: "text", required: true },
      { name: "heberge_prenom", label: "Prénom de la personne hébergée", type: "text", required: true },
      { name: "heberge_date_naissance", label: "Date de naissance de la personne hébergée", type: "date", required: true },
      { name: "lien_parente", label: "Lien avec l'hébergeur", type: "text", required: true, placeholder: "fils, ami, collègue..." },
      { name: "date_debut", label: "Date de début d'hébergement", type: "date", required: true },
      { name: "lieu_signature", label: "Fait à", type: "text", required: true, placeholder: "Paris" },
      { name: "date_document", label: "Date du document", type: "date", required: true }
    ]
  },

  "attestation-domicile": {
    id: "attestation-domicile",
    category_id: "attestations",
    name: "Attestation de domicile",
    description: "Justifiez officiellement votre lieu de résidence actuel.",
    fields: [
      ...EXPEDITEUR_FIELDS,
      { name: "date_naissance", label: "Date de naissance", type: "date", required: true },
      { name: "lieu_naissance", label: "Lieu de naissance", type: "text", required: true, placeholder: "Paris" },
      { name: "date_installation", label: "Date d'installation à cette adresse", type: "date", required: true },
      { name: "lieu_signature", label: "Fait à", type: "text", required: true, placeholder: "Paris" },
      { name: "date_document", label: "Date du document", type: "date", required: true }
    ]
  },

  "declaration-situation": {
    id: "declaration-situation",
    category_id: "attestations",
    name: "Déclaration de situation personnelle",
    description: "Déclarez votre situation familiale, professionnelle ou personnelle.",
    fields: [
      ...EXPEDITEUR_FIELDS,
      { name: "date_naissance", label: "Date de naissance", type: "date", required: true },
      { name: "lieu_naissance", label: "Lieu de naissance", type: "text", required: true, placeholder: "Paris" },
      { name: "situation", label: "Description de la situation", type: "textarea", required: true, placeholder: "Je déclare être dans la situation suivante..." },
      { name: "lieu_signature", label: "Fait à", type: "text", required: true, placeholder: "Paris" },
      { name: "date_document", label: "Date du document", type: "date", required: true }
    ]
  },

  "attestation-simple": {
    id: "attestation-simple",
    category_id: "attestations",
    name: "Attestation simple générique",
    description: "Attestation personnalisable pour tout type de déclaration officielle.",
    fields: [
      ...EXPEDITEUR_FIELDS,
      { name: "contenu", label: "Contenu de l'attestation", type: "textarea", required: true, placeholder: "atteste sur l'honneur que..." },
      { name: "lieu_signature", label: "Fait à", type: "text", required: true, placeholder: "Paris" },
      { name: "date_document", label: "Date du document", type: "date", required: true }
    ]
  },

  // ==========================================
  // RÉSILIATIONS
  // ==========================================
  "resiliation-assurance": {
    id: "resiliation-assurance",
    category_id: "resiliation",
    name: "Lettre de résiliation assurance",
    description: "Résiliez votre contrat d'assurance (auto, habitation, santé...).",
    fields: [
      ...EXPEDITEUR_FIELDS,
      ...createDestinataireFields("Nom de l'assureur", "AXA, MAIF, Allianz..."),
      { name: "numero_contrat", label: "Numéro de contrat", type: "text", required: true, placeholder: "AX-2024-123456" },
      { name: "type_assurance", label: "Type d'assurance", type: "select", required: true, options: ["Automobile", "Habitation", "Santé / Mutuelle", "Vie", "Autre"] },
      { name: "motif", label: "Motif de résiliation", type: "select", required: true, options: ["Échéance annuelle", "Loi Hamon (après 1 an)", "Changement de situation", "Augmentation tarifaire", "Autre"] },
      { name: "date_effet", label: "Date d'effet souhaitée", type: "date", required: true },
      { name: "lieu_signature", label: "Fait à", type: "text", required: true, placeholder: "Paris" },
      { name: "date_document", label: "Date du document", type: "date", required: true }
    ]
  },

  "resiliation-internet": {
    id: "resiliation-internet",
    category_id: "resiliation",
    name: "Lettre de résiliation internet / téléphone",
    description: "Résiliez votre abonnement internet, mobile ou téléphonie fixe.",
    fields: [
      ...EXPEDITEUR_FIELDS,
      ...createDestinataireFields("Nom de l'opérateur", "Orange, SFR, Free, Bouygues..."),
      { name: "numero_client", label: "Numéro client / ligne", type: "text", required: true },
      { name: "type_abonnement", label: "Type d'abonnement", type: "select", required: true, options: ["Internet / Box", "Mobile", "Téléphonie fixe", "Pack Internet + Mobile"] },
      { name: "motif", label: "Motif de résiliation", type: "select", required: true, options: ["Déménagement", "Changement d'opérateur", "Fin d'engagement", "Insatisfaction", "Autre"] },
      { name: "date_effet", label: "Date d'effet souhaitée", type: "date", required: true },
      { name: "lieu_signature", label: "Fait à", type: "text", required: true, placeholder: "Paris" },
      { name: "date_document", label: "Date du document", type: "date", required: true }
    ]
  },

  "resiliation-energie": {
    id: "resiliation-energie",
    category_id: "resiliation",
    name: "Lettre de résiliation énergie (EDF / gaz)",
    description: "Résiliez votre contrat d'électricité ou de gaz.",
    fields: [
      ...EXPEDITEUR_FIELDS,
      ...createDestinataireFields("Nom du fournisseur", "EDF, Engie, Total Energies..."),
      { name: "numero_client", label: "Numéro client / PDL / PCE", type: "text", required: true },
      { name: "type_energie", label: "Type d'énergie", type: "select", required: true, options: ["Électricité", "Gaz", "Électricité + Gaz"] },
      { name: "motif", label: "Motif de résiliation", type: "select", required: true, options: ["Déménagement", "Changement de fournisseur", "Autre"] },
      { name: "releve_compteur", label: "Relevé de compteur (si connu)", type: "text", required: false, placeholder: "12345 kWh" },
      { name: "date_effet", label: "Date d'effet souhaitée", type: "date", required: true },
      { name: "lieu_signature", label: "Fait à", type: "text", required: true, placeholder: "Paris" },
      { name: "date_document", label: "Date du document", type: "date", required: true }
    ]
  },

  "resiliation-salle-sport": {
    id: "resiliation-salle-sport",
    category_id: "resiliation",
    name: "Lettre de résiliation salle de sport",
    description: "Résiliez votre abonnement de salle de sport ou fitness.",
    fields: [
      ...EXPEDITEUR_FIELDS,
      ...createDestinataireFields("Nom de la salle / enseigne", "Basic-Fit, Fitness Park..."),
      { name: "numero_membre", label: "Numéro de membre / adhérent", type: "text", required: true },
      { name: "motif", label: "Motif de résiliation", type: "select", required: true, options: ["Déménagement", "Raison médicale", "Fin d'engagement", "Autre"] },
      { name: "date_effet", label: "Date d'effet souhaitée", type: "date", required: true },
      { name: "lieu_signature", label: "Fait à", type: "text", required: true, placeholder: "Paris" },
      { name: "date_document", label: "Date du document", type: "date", required: true }
    ]
  },

  "preavis-logement": {
    id: "preavis-logement",
    category_id: "resiliation",
    name: "Lettre de préavis de départ (logement)",
    description: "Informez votre bailleur de votre intention de quitter le logement.",
    fields: [
      ...EXPEDITEUR_FIELDS,
      // Destinataire = Bailleur
      { name: "dest_organisme", label: "Nom du bailleur / agence", type: "text", required: true },
      { name: "dest_service", label: "Service", type: "text", required: false, placeholder: "(optionnel)" },
      { name: "dest_adresse_ligne1", label: "Adresse du bailleur – ligne 1", type: "text", required: true },
      { name: "dest_adresse_ligne2", label: "Adresse du bailleur – ligne 2", type: "text", required: false },
      { name: "dest_code_postal", label: "Code postal du bailleur", type: "text", required: true },
      { name: "dest_ville", label: "Ville du bailleur", type: "text", required: true },
      { name: "type_bail", label: "Type de bail", type: "select", required: true, options: ["Location vide (préavis 3 mois)", "Location meublée (préavis 1 mois)", "Zone tendue (préavis 1 mois)"] },
      { name: "date_depart", label: "Date de départ souhaitée", type: "date", required: true },
      { name: "nouvelle_adresse_ligne1", label: "Nouvelle adresse – ligne 1 (pour dépôt de garantie)", type: "text", required: false },
      { name: "nouvelle_adresse_ligne2", label: "Nouvelle adresse – ligne 2", type: "text", required: false },
      { name: "nouvelle_code_postal", label: "Nouveau code postal", type: "text", required: false },
      { name: "nouvelle_ville", label: "Nouvelle ville", type: "text", required: false },
      { name: "lieu_signature", label: "Fait à", type: "text", required: true, placeholder: "Paris" },
      { name: "date_document", label: "Date du document", type: "date", required: true }
    ]
  },

  // ==========================================
  // RÉCLAMATIONS
  // ==========================================
  "lettre-reclamation": {
    id: "lettre-reclamation",
    category_id: "reclamations",
    name: "Lettre de réclamation",
    description: "Adressez une réclamation officielle à une entreprise ou administration.",
    fields: [
      ...EXPEDITEUR_FIELDS,
      ...createDestinataireFields("Nom de l'entreprise / organisme", "Nom de l'entreprise..."),
      { name: "objet", label: "Objet de la réclamation", type: "text", required: true, placeholder: "Réclamation suite à..." },
      { name: "reference", label: "Référence (commande, dossier...)", type: "text", required: false },
      { name: "description", label: "Description du problème", type: "textarea", required: true },
      { name: "demande", label: "Ce que vous demandez", type: "textarea", required: true },
      { name: "lieu_signature", label: "Fait à", type: "text", required: true, placeholder: "Paris" },
      { name: "date_document", label: "Date du document", type: "date", required: true }
    ]
  },

  "demande-remboursement": {
    id: "demande-remboursement",
    category_id: "reclamations",
    name: "Lettre de demande de remboursement",
    description: "Demandez le remboursement d'un produit, service ou trop-perçu.",
    fields: [
      ...EXPEDITEUR_FIELDS,
      ...createDestinataireFields("Nom de l'entreprise / organisme", "Nom de l'entreprise..."),
      { name: "reference", label: "Référence (commande, facture...)", type: "text", required: true },
      { name: "montant", label: "Montant à rembourser", type: "text", required: true, placeholder: "150,00 €" },
      { name: "motif", label: "Motif de la demande", type: "textarea", required: true },
      { name: "iban", label: "IBAN (pour virement)", type: "text", required: false, placeholder: "FR76 XXXX XXXX XXXX" },
      { name: "lieu_signature", label: "Fait à", type: "text", required: true, placeholder: "Paris" },
      { name: "date_document", label: "Date du document", type: "date", required: true }
    ]
  },

  "contestation": {
    id: "contestation",
    category_id: "reclamations",
    name: "Lettre de contestation",
    description: "Contestez une facture, des frais ou une décision administrative.",
    fields: [
      ...EXPEDITEUR_FIELDS,
      ...createDestinataireFields("Nom de l'organisme / entreprise", "Nom de l'organisme..."),
      { name: "type_contestation", label: "Type de contestation", type: "select", required: true, options: ["Facture", "Frais bancaires", "Décision administrative", "Amende", "Autre"] },
      { name: "reference", label: "Référence du document contesté", type: "text", required: true },
      { name: "arguments", label: "Motifs de contestation", type: "textarea", required: true },
      { name: "demande", label: "Ce que vous demandez", type: "textarea", required: true },
      { name: "lieu_signature", label: "Fait à", type: "text", required: true, placeholder: "Paris" },
      { name: "date_document", label: "Date du document", type: "date", required: true }
    ]
  },

  "mise-en-demeure": {
    id: "mise-en-demeure",
    category_id: "reclamations",
    name: "Lettre de mise en demeure simple",
    description: "Mettez en demeure un débiteur ou un prestataire défaillant.",
    fields: [
      ...EXPEDITEUR_FIELDS,
      ...createDestinataireFields("Nom du destinataire", "Nom de la personne ou entreprise..."),
      { name: "objet", label: "Objet de la mise en demeure", type: "text", required: true },
      { name: "description", label: "Description de la situation", type: "textarea", required: true },
      { name: "montant", label: "Montant dû (si applicable)", type: "text", required: false, placeholder: "500,00 €" },
      { name: "delai", label: "Délai accordé (en jours)", type: "text", required: true, placeholder: "8" },
      { name: "lieu_signature", label: "Fait à", type: "text", required: true, placeholder: "Paris" },
      { name: "date_document", label: "Date du document", type: "date", required: true }
    ]
  },

  "lettre-explicative": {
    id: "lettre-explicative",
    category_id: "reclamations",
    name: "Lettre explicative / justificative",
    description: "Expliquez une situation ou justifiez une demande auprès d'un organisme.",
    fields: [
      ...EXPEDITEUR_FIELDS,
      ...createDestinataireFields("Nom de l'organisme / entreprise", "Nom de l'organisme..."),
      { name: "objet", label: "Objet", type: "text", required: true },
      { name: "reference", label: "Référence dossier", type: "text", required: false },
      { name: "explication", label: "Explication détaillée", type: "textarea", required: true },
      { name: "lieu_signature", label: "Fait à", type: "text", required: true, placeholder: "Paris" },
      { name: "date_document", label: "Date du document", type: "date", required: true }
    ]
  },

  // ==========================================
  // LOGEMENT
  // ==========================================
  "lettre-bailleur": {
    id: "lettre-bailleur",
    category_id: "logement",
    name: "Lettre au bailleur",
    description: "Adressez une demande ou signalez un problème à votre propriétaire.",
    fields: [
      ...EXPEDITEUR_FIELDS,
      { name: "dest_organisme", label: "Nom du bailleur / agence", type: "text", required: true },
      { name: "dest_service", label: "Service", type: "text", required: false },
      { name: "dest_adresse_ligne1", label: "Adresse du bailleur – ligne 1", type: "text", required: true },
      { name: "dest_adresse_ligne2", label: "Adresse du bailleur – ligne 2", type: "text", required: false },
      { name: "dest_code_postal", label: "Code postal du bailleur", type: "text", required: true },
      { name: "dest_ville", label: "Ville du bailleur", type: "text", required: true },
      { name: "type_demande", label: "Type de demande", type: "select", required: true, options: ["Demande de travaux", "Signalement de problème", "Demande d'autorisation", "Autre"] },
      { name: "description", label: "Description de la demande", type: "textarea", required: true },
      { name: "lieu_signature", label: "Fait à", type: "text", required: true, placeholder: "Paris" },
      { name: "date_document", label: "Date du document", type: "date", required: true }
    ]
  },

  "lettre-syndic": {
    id: "lettre-syndic",
    category_id: "logement",
    name: "Lettre au syndic / copropriété",
    description: "Adressez une demande ou réclamation au syndic de copropriété.",
    fields: [
      ...EXPEDITEUR_FIELDS,
      { name: "dest_organisme", label: "Nom du syndic", type: "text", required: true },
      { name: "dest_service", label: "Service", type: "text", required: false },
      { name: "dest_adresse_ligne1", label: "Adresse du syndic – ligne 1", type: "text", required: true },
      { name: "dest_adresse_ligne2", label: "Adresse du syndic – ligne 2", type: "text", required: false },
      { name: "dest_code_postal", label: "Code postal du syndic", type: "text", required: true },
      { name: "dest_ville", label: "Ville du syndic", type: "text", required: true },
      { name: "objet", label: "Objet", type: "text", required: true },
      { name: "description", label: "Description de la demande", type: "textarea", required: true },
      { name: "lieu_signature", label: "Fait à", type: "text", required: true, placeholder: "Paris" },
      { name: "date_document", label: "Date du document", type: "date", required: true }
    ]
  },

  "demande-logement": {
    id: "demande-logement",
    category_id: "logement",
    name: "Demande de logement / inscription",
    description: "Candidatez pour un logement social ou une location.",
    fields: [
      ...EXPEDITEUR_FIELDS,
      { name: "telephone", label: "Téléphone", type: "text", required: true },
      { name: "email", label: "Email", type: "text", required: false },
      ...createDestinataireFields("Nom de l'organisme", "Nom du bailleur social..."),
      { name: "situation", label: "Situation actuelle", type: "textarea", required: true },
      { name: "type_logement", label: "Type de logement souhaité", type: "text", required: true, placeholder: "T2, T3..." },
      { name: "motivation", label: "Motivation", type: "textarea", required: true },
      { name: "lieu_signature", label: "Fait à", type: "text", required: true, placeholder: "Paris" },
      { name: "date_document", label: "Date du document", type: "date", required: true }
    ]
  },

  "lettre-mairie": {
    id: "lettre-mairie",
    category_id: "logement",
    name: "Lettre administrative simple (mairie, organisme)",
    description: "Adressez une demande officielle à la mairie ou un organisme public.",
    fields: [
      ...EXPEDITEUR_FIELDS,
      { name: "dest_organisme", label: "Nom de l'organisme", type: "text", required: true, placeholder: "Mairie de Paris" },
      { name: "dest_service", label: "Service / À l'attention de", type: "text", required: false, placeholder: "Monsieur le Maire" },
      { name: "dest_adresse_ligne1", label: "Adresse – ligne 1", type: "text", required: true },
      { name: "dest_adresse_ligne2", label: "Adresse – ligne 2", type: "text", required: false },
      { name: "dest_code_postal", label: "Code postal", type: "text", required: true },
      { name: "dest_ville", label: "Ville", type: "text", required: true },
      { name: "objet", label: "Objet de la demande", type: "text", required: true },
      { name: "contenu", label: "Contenu de la demande", type: "textarea", required: true },
      { name: "lieu_signature", label: "Fait à", type: "text", required: true, placeholder: "Paris" },
      { name: "date_document", label: "Date du document", type: "date", required: true }
    ]
  },

  // ==========================================
  // TRAVAIL
  // ==========================================
  "lettre-employeur": {
    id: "lettre-employeur",
    category_id: "travail",
    name: "Lettre pour employeur",
    description: "Adressez une demande officielle à votre employeur (absence, congé, aménagement).",
    fields: [
      ...EXPEDITEUR_FIELDS,
      { name: "dest_organisme", label: "Nom de l'entreprise", type: "text", required: true },
      { name: "dest_service", label: "Service / Direction", type: "text", required: false },
      { name: "dest_adresse_ligne1", label: "Adresse de l'entreprise – ligne 1", type: "text", required: true },
      { name: "dest_adresse_ligne2", label: "Adresse – ligne 2", type: "text", required: false },
      { name: "dest_code_postal", label: "Code postal", type: "text", required: true },
      { name: "dest_ville", label: "Ville", type: "text", required: true },
      { name: "poste", label: "Votre poste", type: "text", required: true },
      { name: "type_demande", label: "Type de demande", type: "select", required: true, options: ["Demande de congé", "Justification d'absence", "Demande d'aménagement", "Demande de télétravail", "Autre"] },
      { name: "description", label: "Description de la demande", type: "textarea", required: true },
      { name: "dates", label: "Dates concernées (si applicable)", type: "text", required: false },
      { name: "lieu_signature", label: "Fait à", type: "text", required: true, placeholder: "Paris" },
      { name: "date_document", label: "Date du document", type: "date", required: true }
    ]
  },

  "demande-exceptionnelle": {
    id: "demande-exceptionnelle",
    category_id: "travail",
    name: "Lettre de demande exceptionnelle",
    description: "Formulez une demande particulière auprès de votre hiérarchie.",
    fields: [
      ...EXPEDITEUR_FIELDS,
      { name: "dest_organisme", label: "Nom de l'entreprise", type: "text", required: true },
      { name: "dest_service", label: "À l'attention de", type: "text", required: false },
      { name: "dest_adresse_ligne1", label: "Adresse – ligne 1", type: "text", required: true },
      { name: "dest_adresse_ligne2", label: "Adresse – ligne 2", type: "text", required: false },
      { name: "dest_code_postal", label: "Code postal", type: "text", required: true },
      { name: "dest_ville", label: "Ville", type: "text", required: true },
      { name: "objet", label: "Objet de la demande", type: "text", required: true },
      { name: "description", label: "Description et justification", type: "textarea", required: true },
      { name: "lieu_signature", label: "Fait à", type: "text", required: true, placeholder: "Paris" },
      { name: "date_document", label: "Date du document", type: "date", required: true }
    ]
  },

  "lettre-motivation": {
    id: "lettre-motivation",
    category_id: "travail",
    name: "Lettre de motivation simple",
    description: "Rédigez une lettre de motivation professionnelle et efficace.",
    fields: [
      ...EXPEDITEUR_FIELDS,
      { name: "telephone", label: "Téléphone", type: "text", required: true },
      { name: "email", label: "Email", type: "text", required: true },
      { name: "dest_organisme", label: "Nom de l'entreprise", type: "text", required: true },
      { name: "dest_service", label: "Service recrutement / RH", type: "text", required: false },
      { name: "dest_adresse_ligne1", label: "Adresse de l'entreprise – ligne 1", type: "text", required: true },
      { name: "dest_adresse_ligne2", label: "Adresse – ligne 2", type: "text", required: false },
      { name: "dest_code_postal", label: "Code postal", type: "text", required: true },
      { name: "dest_ville", label: "Ville", type: "text", required: true },
      { name: "poste", label: "Poste visé", type: "text", required: true },
      { name: "parcours", label: "Votre parcours en bref", type: "textarea", required: true },
      { name: "motivation", label: "Vos motivations", type: "textarea", required: true },
      { name: "competences", label: "Vos compétences clés", type: "textarea", required: true },
      { name: "lieu_signature", label: "Fait à", type: "text", required: true, placeholder: "Paris" },
      { name: "date_document", label: "Date du document", type: "date", required: true }
    ]
  },

  "demande-stage": {
    id: "demande-stage",
    category_id: "travail",
    name: "Lettre de demande de stage",
    description: "Candidatez pour un stage avec une lettre professionnelle.",
    fields: [
      ...EXPEDITEUR_FIELDS,
      { name: "telephone", label: "Téléphone", type: "text", required: true },
      { name: "email", label: "Email", type: "text", required: true },
      { name: "formation", label: "Formation actuelle", type: "text", required: true },
      { name: "etablissement", label: "Établissement scolaire", type: "text", required: true },
      { name: "dest_organisme", label: "Nom de l'entreprise", type: "text", required: true },
      { name: "dest_service", label: "Service", type: "text", required: false },
      { name: "dest_adresse_ligne1", label: "Adresse de l'entreprise – ligne 1", type: "text", required: true },
      { name: "dest_adresse_ligne2", label: "Adresse – ligne 2", type: "text", required: false },
      { name: "dest_code_postal", label: "Code postal", type: "text", required: true },
      { name: "dest_ville", label: "Ville", type: "text", required: true },
      { name: "domaine", label: "Domaine du stage", type: "text", required: true },
      { name: "duree", label: "Durée souhaitée", type: "text", required: true },
      { name: "dates", label: "Période souhaitée", type: "text", required: true },
      { name: "motivation", label: "Motivations", type: "textarea", required: true },
      { name: "lieu_signature", label: "Fait à", type: "text", required: true, placeholder: "Paris" },
      { name: "date_document", label: "Date du document", type: "date", required: true }
    ]
  },

  "lettre-etablissement": {
    id: "lettre-etablissement",
    category_id: "travail",
    name: "Lettre pour établissement scolaire",
    description: "Adressez une demande à une école, collège, lycée ou université.",
    fields: [
      { name: "nom", label: "Nom du parent / responsable", type: "text", required: true, placeholder: "DUPONT" },
      { name: "prenom", label: "Prénom du parent / responsable", type: "text", required: true, placeholder: "Jean" },
      { name: "adresse_ligne1", label: "Adresse – ligne 1", type: "text", required: true },
      { name: "adresse_ligne2", label: "Adresse – ligne 2", type: "text", required: false },
      { name: "code_postal", label: "Code postal", type: "text", required: true },
      { name: "ville", label: "Ville", type: "text", required: true },
      { name: "nom_eleve", label: "Nom de l'élève", type: "text", required: true },
      { name: "prenom_eleve", label: "Prénom de l'élève", type: "text", required: true },
      { name: "classe", label: "Classe", type: "text", required: true },
      { name: "dest_organisme", label: "Nom de l'établissement", type: "text", required: true },
      { name: "dest_service", label: "À l'attention de", type: "text", required: false, placeholder: "Monsieur/Madame le/la Directeur/trice" },
      { name: "dest_adresse_ligne1", label: "Adresse de l'établissement – ligne 1", type: "text", required: true },
      { name: "dest_adresse_ligne2", label: "Adresse – ligne 2", type: "text", required: false },
      { name: "dest_code_postal", label: "Code postal", type: "text", required: true },
      { name: "dest_ville", label: "Ville", type: "text", required: true },
      { name: "objet", label: "Objet de la lettre", type: "text", required: true },
      { name: "contenu", label: "Contenu de la demande", type: "textarea", required: true },
      { name: "lieu_signature", label: "Fait à", type: "text", required: true, placeholder: "Paris" },
      { name: "date_document", label: "Date du document", type: "date", required: true }
    ]
  }
};

export const getCategoryById = (categoryId) => {
  return CATEGORIES.find(c => c.id === categoryId);
};

export const getDocumentsByCategory = (categoryId) => {
  return DOCUMENTS_LIST[categoryId] || [];
};

export const getDocumentById = (documentId) => {
  return DOCUMENTS[documentId] || null;
};

export const getAllDocuments = () => {
  return Object.values(DOCUMENTS_LIST).flat();
};
